import { channels } from '@/mocks/channels';
import { resolveTone, toneStyles } from '@/utils/tone';

export default function ChannelDetailList() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <aside className="lg:col-span-3">
            <div className="lg:sticky lg:top-28">
              <p className="text-xs font-label tracking-[0.2em] uppercase text-foreground-500">频道索引</p>
              <nav className="mt-4 flex flex-col gap-1" aria-label="频道索引">
                {channels.map((channel) => (
                  <a
                    key={channel.slug}
                    href={`#channel-${channel.slug}`}
                    className="group flex items-center justify-between gap-3 px-3 py-2.5 rounded-md text-sm font-label text-foreground-700 hover:bg-background-50 hover:text-primary-700 transition-colors"
                  >
                    <span className="flex items-center gap-2.5 min-w-0">
                      <i className={`${channel.icon} text-foreground-400 group-hover:text-primary-500`} aria-hidden="true" />
                      <span className="truncate">{channel.name}</span>
                    </span>
                    <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          <div className="lg:col-span-9 flex flex-col gap-6">
            {channels.map((channel) => {
              const tone = toneStyles[resolveTone(channel.tone)];
              return (
                <article
                  key={channel.slug}
                  id={`channel-${channel.slug}`}
                  className="scroll-mt-28 rounded-lg border border-background-300/60 bg-background-50 p-5 md:p-7"
                >
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <span className={`w-12 h-12 rounded-lg flex items-center justify-center ${tone.iconBox}`}>
                        <i className={`${channel.icon} text-2xl`} aria-hidden="true" />
                      </span>
                      <div>
                        <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{channel.name}</h3>
                        <p className="mt-1 text-xs font-label text-foreground-500">
                          {channel.cadence} · 已收录 {channel.volume} 篇
                        </p>
                      </div>
                    </div>
                    <div className={`h-1.5 w-full sm:w-24 rounded-full ${tone.bar}`} aria-hidden="true" />
                  </div>

                  <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">{channel.summary}</p>

                  <div className="mt-5 flex flex-wrap gap-2">
                    {channel.tags.map((tag) => (
                      <span key={tag} className={`text-xs font-label px-3 py-1.5 rounded-full ${tone.chip}`}>
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="rounded-md border border-background-300/60 bg-background-100/60 px-4 py-3">
                      <p className="text-xs font-label text-foreground-500">选题侧重</p>
                      <p className="mt-1 text-sm text-foreground-900">{channel.tags[0]}</p>
                    </div>
                    <div className="rounded-md border border-background-300/60 bg-background-100/60 px-4 py-3">
                      <p className="text-xs font-label text-foreground-500">更新节奏</p>
                      <p className="mt-1 text-sm text-foreground-900">{channel.cadence}</p>
                    </div>
                    <div className="rounded-md border border-background-300/60 bg-background-100/60 px-4 py-3">
                      <p className="text-xs font-label text-foreground-500">内容形态</p>
                      <p className="mt-1 text-sm text-foreground-900">爆料 + 追踪 + 指南</p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}